import { Stack, Typography } from '@mui/material';

import AppLink from '@/components/AppLink';
import { Tabs as SettingsTabs } from '@/pages/Settings/Tabs/types';
import { BasetenPageEnum } from '@/routes';

import Gauge from './Gauge';
import { HybridCreditCalloutProps } from './types';

function HybridCreditCallout({
  title,
  description,
  creditsIssuedCents,
  creditsRemainingCents,
  hasCreditCard,
}: HybridCreditCalloutProps) {
  return (
    <Stack
      sx={{
        width: 320,
        borderRadius: 1,
      }}
    >
      <Stack gap={1}>
        <Typography variant="h5">{title}</Typography>
        <Typography variant="body1" color="text.muted">
          {description}{' '}
          <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.Billing }}>
            View usage
          </AppLink>
        </Typography>
        <Gauge
          max={creditsIssuedCents}
          value={creditsRemainingCents}
          hasCreditCard={hasCreditCard}
        />
      </Stack>
    </Stack>
  );
}

export { HybridCreditCallout };
